<template lang="pug">
  .container-settle.container-padding
    c-header
      template(slot="left")
        el-breadcrumb(separator="/")
          el-breadcrumb-item(to="/settle") 结算账户管理
          el-breadcrumb-item 富力钱包
          el-breadcrumb-item 开通成功
    c-box
      .finish 
        i.el-icon-success.icon
        .txt-intro 富力钱包开通成功
        el-button(@click="next",type="primary", round) 进入富力钱包
</template>

<script>
export default {
  data() {
    return {
    };
  },
  computed: {},
  methods: {
    next(){
      this.$router.push(`/wallet/detail/${this.$route.params.settle_account}/${this.$route.params.settle_id}`)
    }
  },


};
</script>
<style lang="less" scoped>
.finish{
  min-height: 500px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items:center;
  .txt-intro{
    font-weight: 600;
    margin: 20px 0;
  }
}
.icon{
  font-size: 128px;
  color: #67C23A;
}
</style>

